var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.initials)?_c('v-avatar',{class:("profile-pic " + (_vm.$store.getters['auth/user'] &&
    _vm.$store.getters['auth/user'].theme_config.key == 'lifechamps'
      ? 'white--text'
      : '')),attrs:{"size":"48"}},[_vm._v(" "+_vm._s(_vm.initials)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }